import { IGetInfrastructureResponse } from '../repositories/newbuilding-card/v1/get-infrastructure';
import { IFutureRoad } from '../types/map';

export const transformFutureRoads = (futureRoads: IGetInfrastructureResponse['futureRoads']): IFutureRoad[] => {
  if (!futureRoads) {
    return [];
  }

  return futureRoads.map(road => ({
    ...road,
    type: 'futureRoad',
    constructionYearTo: road.constructionYearTo || undefined,
  }));
};
